/* FloraVines mobile performance: defer non-critical third-party bundles until intent.
   A bounded fallback preserves app functionality for users who do not interact. */
(() => {
  let started = false;

  const loadDeferredScripts = () => {
    if (started) return;
    started = true;
    cleanup();

    const scripts = [...document.querySelectorAll('script[data-fv-deferred-src]')];
    let chain = Promise.resolve();

    scripts.forEach((placeholder) => {
      chain = chain.then(() => new Promise((resolve) => {
        const script = document.createElement('script');
        for (const attr of placeholder.attributes) {
          if (attr.name !== 'data-fv-deferred-src' && attr.name !== 'src') {
            script.setAttribute(attr.name, attr.value);
          }
        }
        script.src = placeholder.dataset.fvDeferredSrc;
        script.async = true;
        script.onload = script.onerror = resolve;
        placeholder.replaceWith(script);
      }));
    });
  };

  const events = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
  const opts = { once: true, passive: true };
  const onIntent = () => loadDeferredScripts();

  const cleanup = () => {
    events.forEach((eventName) => window.removeEventListener(eventName, onIntent, opts));
  };

  const arm = () => {
    events.forEach((eventName) => window.addEventListener(eventName, onIntent, opts));
    // Do not starve chat/loyalty forever when a visitor only reads.
    setTimeout(loadDeferredScripts, 8000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm, { once: true });
  } else {
    arm();
  }
})();
